import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal, Overline } from "@/components/motion";

const FAQS = [
  { q: "Which areas do you cover?", a: "Full service — we install, fill, clean and service the machine — across London and the Home Counties, out as far as Oxford and Reading. Outside that area we still supply you: we ship beans, milk and consumables on a schedule, your team restocks and runs the machine's daily clean cycle, and the 22p-per-cup donation works exactly the same." },
  { q: "How is the 22p calculated and paid?", a: "Flat and simple: 22p per cup dispensed, counted from the machine's sales report every week. Totals are published on your location page every Monday, and donations are paid to your chosen registered UK charity on a regular agreed schedule. No percentage-of-profit ambiguity." },
  { q: "What does it cost us as a host?", a: "Nothing. No install fee, no rental, no servicing charge. Your team pays for their coffee at the machine, and we cover the rest." },
  { q: "Who cleans and maintains the machine?", a: "The machine runs automated daily cleaning cycles. Inside our service area we restock, deep-clean and service it on a regular schedule; outside it we ship supplies and your team restocks. Either way, we deliver, install and plumb in the machine — and any maintenance or repairs it ever needs are taken care of by us, wherever you're based." },
  { q: "Which charities can we choose?", a: "Any registered UK charity. For our first machines we recommend starting from a shortlist we already work with — it keeps vetting and payout admin fast — but the choice is yours." },
  { q: "How long is the contract?", a: "30-day rolling. No multi-year lock-in. If things change, pause or cancel with 30 days' notice and we collect the machine." },
  { q: "How do people see the impact?", a: "Every machine carries a QR code linking to its live location page — cups poured, pounds raised and the story of the charity you're funding, updated every Monday." },
];

export const Faq = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="py-24 sm:py-32 bg-[#F7F5F0]">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <Reveal><Overline>Questions, answered</Overline></Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-4 font-display font-bold tracking-tight text-[#0B1E17] text-2xl sm:text-3xl lg:text-4xl leading-tight">
            Frequently asked questions
          </h2>
        </Reveal>
        <div className="mt-10 space-y-3" data-testid="faq-list">
          {FAQS.map((f, i) => (
            <Reveal key={f.q} delay={0.05 + i * 0.04}>
              <div className="bg-white rounded-2xl border border-[#E2DDD3] overflow-hidden">
                <button data-testid={`faq-question-${i}`} onClick={() => setOpen(open === i ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left">
                  <span className="font-display font-bold text-base text-[#0B1E17]">{f.q}</span>
                  <motion.span animate={{ rotate: open === i ? 45 : 0 }} transition={{ duration: 0.3 }}
                    className="text-[#D97706] font-bold text-xl shrink-0">+</motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.35, ease: [0.215, 0.61, 0.355, 1] }}>
                      <p data-testid={`faq-answer-${i}`} className="px-6 pb-6 text-sm text-[#52665E] leading-relaxed">{f.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
